export const getEscalationTooltip = (fieldDisplayName: string): string =>
  `Setting "${fieldDisplayName}" will determine the order in which the notif will escalate to the assignments, units, and other units in same building.`;
